import React, { useEffect, useState } from "react";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import "../../../libs/css/bootstrap.min3.3.7.css";
import "../../../libs/css/sweetalert2.min.css";
import { API_ROUTES } from "../../../utils/constants";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

const networkData = [
  { id: "1", name: "MTN" },
  { id: "2", name: "GLO" },
  { id: "3", name: "AIRTEL" },
  { id: "4", name: "9MOBILE" },
];

function getYesterday() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function TopServices(props) {
  const { objectToFormData, isAuthExpired, isLoading1, userSessions = [] } = props;

  useEffect(() => { document.title = "Top Services | Forthsoft"; }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [isFade, setIsFade] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      start_date: getYesterday(),
      end_date: getYesterday(),
      sort_by: "revenue",
      operator: "",
      limit: "10",
    },
  });

  const serviceMap = {};
  userSessions.forEach((s) => {
    serviceMap[String(s.serviceId)] = s.serviceName;
  });

  const networkMap = {};
  networkData.forEach((n) => {
    networkMap[String(n.id)] = n.name;
  });

  const columns = [
    {
      name: "Position",
      selector: (row) => row.position,
      sortable: true,
      cell: (row) => <div style={{ fontWeight: "600" }}>#{row.position}</div>,
      width: "100px",
    },
    {
      name: "Service Name",
      selector: (row) => serviceMap[String(row.serviceId)] || row.serviceId,
      sortable: true,
      cell: (row) => (
        <div style={{ textTransform: "capitalize" }}>
          {serviceMap[String(row.serviceId)] || `ID: ${row.serviceId}`}
        </div>
      ),
    },
    {
      name: "Network",
      selector: (row) => networkMap[String(row.network_id)] || row.network_id,
      sortable: true,
    },
    {
      name: "Total Revenue",
      selector: (row) => Number(row.total_revenue || 0),
      sortable: true,
      cell: (row) => (
        <div>{"₦" + Number(row.total_revenue || 0).toLocaleString()}</div>
      ),
    },
    {
      name: "Total Subscription",
      selector: (row) => Number(row.total_count || 0),
      sortable: true,
      cell: (row) => <div>{Number(row.total_count || 0).toLocaleString()}</div>,
    },
  ];

  const getData = async (filters) => {
    setIsFade(true);
    setIsLoading(true);

    const body = {
      start_date: filters.start_date,
      end_date: filters.end_date,
      sort_by: filters.sort_by,
      limit: filters.limit,
    };
    if (filters.operator) {
      body.operator = filters.operator;
    }

    try {
      const response = await fetch(API_ROUTES.TOP_SERVICES, {
        method: "POST",
        body: objectToFormData(body),
        headers: { token: userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();
      isAuthExpired(responseJSON);

      if (responseJSON.status.toString() === "200") {
        const rows = responseJSON.data || [];

        if (rows.length > 0 && userSessions.length === 0 && !isLoading1) {
          Swal.fire({
            title: "Warning",
            text: "Could not load service names. Please refresh the page.",
            icon: "warning",
          });
        }

        setDataList(rows);
        setHasFetched(true);
        setIsLoading(false);
        setIsFade(false);
      } else {
        setDataList([]);
        setHasFetched(true);
        setIsLoading(false);
        setIsFade(false);
        Swal.fire({
          title: "Error",
          text: responseJSON.message || "Failed to fetch top services",
          icon: "error",
        });
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setDataList([]);
      setHasFetched(false);
      setIsLoading(false);
      setIsFade(false);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    getData({
      start_date: getYesterday(),
      end_date: getYesterday(),
      sort_by: "revenue",
      operator: "",
      limit: "10",
    });
  }, []);

  return (
    <>
      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm mt--20">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid mb-90">
                  <div className="card-header mb--30 mb-xs-10 ml-10">
                    <h2>Top Services</h2>
                  </div>

                  {isLoading1 ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      <div className="row mb-10 mt-40">
                        <form onSubmit={handleSubmit(getData)} className="row">
                          <div className="col-lg-12">
                            <div className="col-sm-2 pr-0">
                              <input
                                type="date"
                                className="filter_text"
                                {...register("start_date", { required: "Start date is required" })}
                                max={new Date().toISOString().substr(0, 10)}
                              />
                              {errors.start_date && (
                                <small className="text-danger">{errors.start_date.message}</small>
                              )}
                            </div>

                            <div className="col-sm-2 pr-0">
                              <input
                                type="date"
                                className="filter_text"
                                {...register("end_date", { required: "End date is required" })}
                                max={new Date().toISOString().substr(0, 10)}
                              />
                              {errors.end_date && (
                                <small className="text-danger">{errors.end_date.message}</small>
                              )}
                            </div>

                            <div className="col-sm-2 pr-0">
                              <select className="filter_text" {...register("sort_by")}>
                                <option value="revenue">Revenue</option>
                                <option value="count">Subscription</option>
                              </select>
                            </div>

                            <div className="col-sm-2 pr-0">
                              <select
                                className="filter_text"
                                {...register("operator")}
                                style={{ textTransform: "capitalize" }}
                              >
                                <option value="">All Networks</option>
                                {networkData.map((n) => (
                                  <option key={n.id} value={n.id}>
                                    {n.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-sm-1 pr-0">
                              <select className="filter_text" {...register("limit")}>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                              </select>
                            </div>

                            <div className="col-sm-3 p-0 pl-5">
                              <button
                                className="btn_1 btn-primary w-100"
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                  opacity: isSubmitting ? "0.5" : 1,
                                  minHeight: "38px",
                                }}
                              >
                                {isSubmitting ? (
                                  <>
                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>
                                    <i className="fa fa-search mr-2"></i>
                                    Filter
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div style={{ opacity: isFade ? "0.3" : 1 }}>
                        {isLoading && <LoadingSpinner />}

                        {!isLoading && hasFetched && dataList.length === 0 && (
                          <div
                            className="mt-20 ml-10"
                            style={{ color: "#888", fontSize: "14px" }}
                          >
                            No data found for the selected period.
                          </div>
                        )}

                        {!isLoading && dataList.length > 0 && (
                          <DataTable
                            className="unsub_datatable users"
                            columns={columns}
                            data={dataList}
                            highlightOnHover
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[20, 50, 100]}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <Footers />
          </div>
        </div>
      </div>
    </>
  );
}
